import React, { useState } from "react";
import SectionHeader from "./SectionHeader";
import { Check, Copy, Plus, Trash2 } from "lucide-react";
import {
    containerTypeOptions,
    packageTypeOptions,
    printBlOptions,
} from "./constant";
import { useSelector } from "react-redux";

function ParticularsFurnished({
    expandedSections,
    onChange = () => { },
    toggleSection,
    formData,
    updateContainer,
    removeContainer,
    addContainer,
}) {
    const [copied, setCopied] = useState(false);
    const totals = {
        containers: formData?.dockReceiptContainer?.length || 0,
        packages: formData?.dockReceiptContainer?.reduce(
            (sum, c) => sum + (parseInt(c?.nopackage) || 0),
            0,
        ),
        netkgs: formData?.dockReceiptContainer
            ?.reduce((sum, c) => sum + (parseFloat(c?.netkgs) || 0), 0)
            .toFixed(3),
        netlbs: formData?.dockReceiptContainer
            ?.reduce((sum, c) => sum + (parseFloat(c?.netlbs) || 0), 0)
            .toFixed(3),
        kgs: formData?.dockReceiptContainer
            ?.reduce((sum, c) => sum + (parseFloat(c?.kgs) || 0), 0)
            .toFixed(3),
        lbs: formData?.dockReceiptContainer
            ?.reduce((sum, c) => sum + (parseFloat(c?.lbs) || 0), 0)
            .toFixed(3),
    };

    const handleCopy = (text) => {
        navigator.clipboard.writeText(text);
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
    };



    const { containerTypeList } = useSelector((state) => state.common);

    const inputClass =
        "w-full px-3 py-2 text-sm border border-slate-200 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 disabled:cursor-not-allowed disabled:bg-slate-100 dark:disabled:bg-slate-700 disabled:opacity-70 transition-all";

    return (
        <div className="rounded border border-slate-200 dark:border-slate-700 overflow-hidden">


            <div className="p-4 space-y-4">
                {/* Options Bar */}
                <div className="flex flex-wrap items-center gap-4 pb-3 border-b border-slate-200 dark:border-slate-700">
                    <div className="flex items-center gap-2">
                        <span className="text-sm text-slate-600 dark:text-slate-400">
                            Print Weight & Measurement:
                        </span>
                        <div className="flex items-center gap-3">
                            {printBlOptions.map((opt) => (
                                <label key={opt} className="flex items-center gap-1 text-sm">
                                    <input
                                        type="radio"
                                        name="engMetricPrint"
                                        value={opt.value}
                                        checked={formData?.engMetricPrint === opt.value}
                                        onChange={(e) =>
                                            onChange("engMetricPrint", e.target.value, "text")
                                        }
                                        className="text-blue-600"
                                    />
                                    <span className="capitalize">{opt.label}</span>
                                </label>
                            ))}
                        </div>
                    </div>
                    <div className="flex-1" />
                    <label className="flex items-center gap-1 text-sm  text-slate-600 dark:text-slate-300">
                        <input
                            type="checkbox"
                            className="rounded"
                            checked={formData?.notautocalculate}
                            onChange={(e) =>
                                onChange("notautocalculate", e.target.checked, "checkbox")
                            }
                        />
                        <span className="capitalize">Do not calculate</span>
                    </label>
                    <label className="flex items-center gap-1 text-sm text-slate-600 dark:text-slate-300">
                        <input
                            type="checkbox"
                            className="rounded"
                            checked={formData?.isprintgroupcommodities}
                            onChange={(e) =>
                                onChange(
                                    "isprintgroupcommodities",
                                    e.target.checked,
                                    "checkbox",
                                )
                            }
                        />
                        Print in Group Commodities
                    </label>
                    <label className="flex items-center gap-1 text-sm text-slate-600 dark:text-slate-300">
                        <input
                            type="checkbox"
                            className="rounded"
                            checked={formData?.isprintwithriderlist}
                            onChange={(e) =>
                                onChange("isprintwithriderlist", e.target.checked, "checkbox")
                            }
                        />
                        Print with RIDER LIST
                    </label>
                </div>

                {/* Import Buttons */}
                <div className="flex items-center gap-3">
                    <button className="px-3 py-1.5 bg-red-600 hover:bg-red-700 text-white text-sm rounded font-medium">
                        Import Cargo from Booking
                    </button>
                    <button className="px-3 py-1.5 bg-red-600 hover:bg-red-700 text-white text-sm rounded font-medium">
                        Import From HBL
                    </button>
                    <div className="flex-1" />
                    <div className="flex items-center gap-2">
                        <input
                            type="text"
                            className="w-64 px-3 py-1.5 text-sm border border-slate-200 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 disabled:cursor-not-allowed disabled:bg-slate-100 dark:disabled:bg-slate-700 disabled:opacity-70 transition-all"
                            placeholder="Enter Cargo Description"
                        />
                        <button className="px-3 py-1.5 bg-green-600 hover:bg-green-700 text-white text-sm rounded font-medium">
                            Fill All
                        </button>
                        <button className="px-3 py-1.5 bg-amber-500 hover:bg-amber-600 text-white text-sm rounded font-medium">
                            Override
                        </button>
                    </div>
                </div>

                {/* Container Table */}
                <div className="border border-slate-200 dark:border-slate-700 rounded overflow-hidden">
                    <table className="w-full text-sm">
                        <thead>
                            <tr className="bg-slate-100 dark:bg-slate-700 text-slate-700 dark:text-slate-300">
                                <th className="px-3 py-2 text-left font-medium border-r border-slate-200 dark:border-slate-600 w-36">
                                    Container
                                </th>
                                <th className="px-3 py-2 text-left font-medium border-r border-slate-200 dark:border-slate-600 w-36">
                                    Type
                                </th>
                                <th className="px-3 py-2 text-left font-medium border-r border-slate-200 dark:border-slate-600">
                                    Qty
                                </th>
                                <th className="px-3 py-2 text-left font-medium border-r border-slate-200 dark:border-slate-600 w-64">
                                    Cargo Description
                                </th>
                                <th className="px-3 py-2 text-center font-medium border-r border-slate-200 dark:border-slate-600 w-36">
                                    Net Weight
                                </th>
                                <th className="px-3 py-2 text-center font-medium border-r border-slate-200 dark:border-slate-600 w-36">
                                    Gross Weight
                                </th>
                                <th className="px-3 py-2 text-center font-medium border-r border-slate-200 dark:border-slate-600 w-26">
                                    Measurement
                                </th>
                                <th className="px-3 py-2 text-center font-medium w-12"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {formData?.dockReceiptContainer?.map((container, idx) => (
                                <tr
                                    key={container?.id}
                                    className="border-t border-slate-200 dark:border-slate-700"
                                >
                                    {/* Container Column */}
                                    <td className="px-3 py-2 border-r border-slate-200 dark:border-slate-600 align-top">
                                        <div className="space-y-1">
                                            <input
                                                type="text"
                                                className={inputClass}
                                                placeholder="Container No"
                                                value={container?.containernumber}
                                                onChange={(e) =>
                                                    updateContainer(
                                                        "containernumber",
                                                        e.target.value,
                                                        idx,
                                                        "text",
                                                    )
                                                }
                                            />
                                            <input
                                                type="text"
                                                className={inputClass}
                                                placeholder="Seal No"
                                                value={container?.sealnumber}
                                                onChange={(e) =>
                                                    updateContainer(
                                                        "sealnumber",
                                                        e.target.value,
                                                        idx,
                                                        "text",
                                                    )
                                                }
                                            />
                                            <input
                                                type="text"
                                                className={inputClass}
                                                placeholder="Marks"
                                                value={container?.marksno}
                                                onChange={(e) =>
                                                    updateContainer(
                                                        "marksno",
                                                        e.target.value,
                                                        idx,
                                                        "text",
                                                    )
                                                }
                                            />
                                        </div>
                                    </td>

                                    {/* Type Column */}
                                    <td className="px-3 py-2 border-r border-slate-200 dark:border-slate-600 align-top">
                                        <div className="space-y-1">
                                            <select
                                                className={inputClass}
                                                value={container?.contypecode}
                                                onChange={(e) => {
                                                    const selectedOption = e.target.options[e.target.selectedIndex];
                                                    updateContainer(
                                                        "contype",
                                                        selectedOption.text,
                                                        idx,
                                                        "text"
                                                    );
                                                    updateContainer(
                                                        "contypecode",
                                                        e.target.value,
                                                        idx,
                                                        "text"
                                                    );
                                                }}

                                            >
                                                <option value={""}>
                                                    Select
                                                </option>
                                                {containerTypeList && (containerTypeList || []).map((item) => (
                                                    <option key={item.moveTypeId} value={item.moveTypeId}>
                                                        {item.moveType}
                                                    </option>
                                                ))}
                                            </select>

                                            <input
                                                type="text"
                                                className={inputClass}
                                                placeholder="Tare Weight"
                                                value={container?.tareweight}
                                                onChange={(e) =>
                                                    updateContainer(
                                                        "tareweight",
                                                        e.target.value,
                                                        idx,
                                                        "text",
                                                    )
                                                } //
                                            />
                                        </div>
                                    </td>

                                    {/* Qty Column */}
                                    <td className="px-3 py-2 border-r border-slate-200 dark:border-slate-600 align-top">
                                        <div className="space-y-1">
                                            <input
                                                type="text"
                                                className={inputClass}
                                                value={container?.nopackage}
                                                placeholder="No Of Pkg"
                                                onChange={(e) =>
                                                    updateContainer(
                                                        "nopackage",
                                                        e.target.value,
                                                        idx,
                                                        "number",
                                                    )
                                                }
                                            />
                                            <select
                                                className={inputClass}
                                                value={container?.packagecode}
                                                onChange={(e) =>
                                                    updateContainer(
                                                        "packagecode",
                                                        e.target.value,
                                                        idx,
                                                        "text"
                                                    )
                                                }
                                            >
                                                {packageTypeOptions.map((item, index) => (
                                                    <option key={index} value={item.value}>
                                                        {item.label}
                                                    </option>
                                                ))}
                                            </select>

                                            <div className="flex gap-1">
                                                <input
                                                    type="text"
                                                    className={inputClass}
                                                    placeholder="HS Code"
                                                    value={container?.scheduleb}
                                                    onChange={(e) =>
                                                        updateContainer(
                                                            "scheduleb",
                                                            e.target.value,
                                                            idx,
                                                            "text",
                                                        )
                                                    } //
                                                />
                                                <button
                                                    onClick={() => handleCopy(container?.scheduleb)}
                                                    className="p-2 rounded hover:bg-slate-100"
                                                >
                                                    {copied ? (
                                                        <Check className="w-4 h-4 text-green-500" />
                                                    ) : (
                                                        <Copy className="w-4 h-4" />
                                                    )}
                                                </button>
                                            </div>

                                            <div className="flex gap-1">
                                                <input
                                                    type="text"
                                                    className={inputClass}
                                                    placeholder="VIN Number"
                                                    value={container?.vinNumber}
                                                    onChange={(e) =>
                                                        updateContainer("vinNumber", e.target.value, idx, "text")
                                                    }
                                                />
                                                <button className="w-24 px-2 py-1 text-xs bg-green-600 hover:bg-green-700 text-white  rounded font-medium">
                                                    Validate
                                                </button>
                                            </div>

                                            <input
                                                type="text"
                                                className={inputClass}
                                                placeholder="Title Number"
                                                value={container?.titleNumber}
                                                onChange={(e) =>
                                                    updateContainer(
                                                        "titleNumber",
                                                        e.target.value,
                                                        idx,
                                                        "text",
                                                    )
                                                }
                                            />

                                            <div className="flex gap-1">
                                                <input
                                                    type="text"
                                                    className={inputClass}
                                                    placeholder="State"
                                                    value={container?.cargoState}
                                                    onChange={(e) =>
                                                        updateContainer(
                                                            "cargoState",
                                                            e.target.value,
                                                            idx,
                                                            "text",
                                                        )
                                                    }
                                                />
                                                <input
                                                    type="text"
                                                    className={inputClass}
                                                    placeholder="Value of Vehicle"
                                                    value={container?.valueofvehicle}
                                                    onChange={(e) =>
                                                        updateContainer(
                                                            "valueofvehicle",
                                                            e.target.value,
                                                            idx,
                                                            "number",
                                                        )
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </td>

                                    {/* Cargo Description Column */}
                                    <td className="px-3 py-2 border-r border-slate-200 dark:border-slate-600 align-top">
                                        <textarea
                                            className={inputClass}
                                            rows={3}
                                            value={container?.descriptions}
                                            onChange={(e) =>
                                                updateContainer(
                                                    "descriptions",
                                                    e.target.value,
                                                    idx,
                                                    "text",
                                                )
                                            } //
                                        />
                                    </td>

                                    {/* Net Weight Column */}
                                    <td className="px-3 py-2 border-r border-slate-200 dark:border-slate-600 align-top">
                                        <div className="space-y-1">
                                            <div className="flex items-center gap-1">
                                                <span className="text-[10px] text-slate-500 w-6">
                                                    KGS
                                                </span>
                                                <input

                                                    type="text"
                                                    className={inputClass}
                                                    value={container?.netkgs}
                                                    onChange={(e) =>
                                                        updateContainer("netkgs", e.target.value, idx, "number")
                                                    }
                                                />
                                            </div>
                                            <div className="flex items-center gap-1">
                                                <span className="text-[10px] text-slate-500 w-6">
                                                    LBS
                                                </span>
                                                <input
                                                    type="text"

                                                    className={inputClass}
                                                    value={container?.netlbs}
                                                    onChange={(e) =>
                                                        updateContainer(
                                                            "netlbs",
                                                            e.target.value,
                                                            idx,
                                                            "number",
                                                        )
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </td>

                                    {/* Gross Weight Column */}
                                    <td className="px-3 py-2 border-r border-slate-200 dark:border-slate-600 align-top bg-amber-50 dark:bg-amber-900/10">
                                        <div className="space-y-1">
                                            <div className="flex items-center gap-1">
                                                <span className="text-[10px] text-slate-500 w-6">
                                                    KGS
                                                </span>
                                                <input
                                                    type="text"
                                                    className={inputClass}
                                                    value={container?.kgs}

                                                    onChange={(e) =>
                                                        updateContainer(
                                                            "kgs",
                                                            e.target.value,
                                                            idx,
                                                            "number",
                                                        )
                                                    }
                                                />
                                            </div>
                                            <div className="flex items-center gap-1">
                                                <span className="text-[10px] text-slate-500 w-6">
                                                    LBS
                                                </span>
                                                <input
                                                    type="text"
                                                    className={inputClass}
                                                    value={container?.lbs}


                                                    onChange={(e) =>
                                                        updateContainer(
                                                            "lbs",
                                                            e.target.value,
                                                            idx,
                                                            "number",
                                                        )
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </td>

                                    {/* Measurement Column */}
                                    <td className="px-3 py-2 border-r border-slate-200 dark:border-slate-600 align-top">
                                        <div className="space-y-1">
                                            <div className="flex items-center gap-1">
                                                <span className="text-[10px] text-slate-500 w-6">
                                                    CBM
                                                </span>
                                                <input
                                                    type="text"
                                                    className={inputClass}
                                                    value={container?.cbm}


                                                    onChange={(e) =>
                                                        updateContainer(
                                                            "cbm",
                                                            e.target.value,
                                                            idx,
                                                            "number",
                                                        )
                                                    }
                                                />
                                            </div>
                                            <div className="flex items-center gap-1">
                                                <span className="text-[10px] text-slate-500 w-6">
                                                    CFT
                                                </span>
                                                <input
                                                    type="text"
                                                    className={inputClass}
                                                    value={container?.cft}

                                                    onChange={(e) =>
                                                        updateContainer(
                                                            "cft",
                                                            e.target.value,
                                                            idx,
                                                            "number",
                                                        )
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </td>

                                    {/* Delete Column */}
                                    <td className="px-3 py-2 align-top text-center">
                                        <button
                                            onClick={() => removeContainer(idx)}
                                            className="p-1 text-red-500 hover:bg-red-50 rounded"
                                            disabled={formData?.dockReceiptContainer?.length === 1}
                                        >
                                            <Trash2 className="w-4 h-4" />
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                {/* Add Button */}
                <div className="flex justify-center">
                    <button
                        onClick={addContainer}
                        className="px-4 py-2 bg-green-600 hover:bg-green-700 text-white text-sm rounded font-medium flex items-center gap-2"
                    >
                        <Plus className="w-4 h-4" />
                        Add More
                    </button>
                </div>

                {/* Totals */}
                <div className="bg-slate-50 dark:bg-slate-700/50 rounded p-3">
                    <div className="grid grid-cols-6 gap-4 text-sm">
                        <div className="text-center">
                            <div className="text-xs text-slate-500 mb-1">
                                Total Containers
                            </div>
                            <div className="font-semibold">{totals?.containers}</div>
                        </div>
                        <div className="text-center">
                            <div className="text-xs text-slate-500 mb-1">
                                Total Packages
                            </div>
                            <div className="font-semibold">{totals?.packages}</div>
                        </div>
                        <div className="text-center">
                            <div className="text-xs text-slate-500 mb-1">Net KGS</div>
                            <div className="font-semibold">{totals?.netkgs}</div>
                        </div>
                        <div className="text-center">
                            <div className="text-xs text-slate-500 mb-1">Net LBS</div>
                            <div className="font-semibold">{totals?.netlbs}</div>
                        </div>
                        <div className="text-center bg-amber-100 dark:bg-amber-900/30 rounded py-1">
                            <div className="text-xs text-amber-700 dark:text-amber-400 mb-1">
                                Gross KGS
                            </div>
                            <div className="font-semibold text-amber-700 dark:text-amber-400">
                                {totals?.kgs}
                            </div>
                        </div>
                        <div className="text-center bg-amber-100 dark:bg-amber-900/30 rounded py-1">
                            <div className="text-xs text-amber-700 dark:text-amber-400 mb-1">
                                Gross LBS
                            </div>
                            <div className="font-semibold text-amber-700 dark:text-amber-400">
                                {totals?.lbs}
                            </div>
                        </div>
                    </div>
                </div>

                {/* L/C Option */}
                <div className="flex items-center gap-3 pt-3 border-t border-slate-200 dark:border-slate-700">
                    <span className="text-sm text-slate-600">
                        Show L/C or Manual Particulars Furnished by Shipper:
                    </span>
                    <label className="flex items-center gap-1 text-sm">
                        <input
                            type="radio"
                            name="islcManualdetails"
                            value="yes"
                            className="text-blue-600"
                            checked={formData?.islcManualdetails === true}
                            onChange={(e) =>
                                onChange("islcManualdetails", true, "checkbox")
                            }
                        />
                        Yes
                    </label>
                    <label className="flex items-center gap-1 text-sm">
                        <input
                            type="radio"
                            name="islcManualdetails"
                            value="no"
                            checked={formData?.islcManualdetails === false}
                            className="text-blue-600"
                            onChange={(e) =>
                                onChange("islcManualdetails", false, "checkbox")
                            }
                        />
                        No
                    </label>
                </div>
            </div>

        </div>
    );
}

export default ParticularsFurnished;